import React from 'react';

const HourGlassRedUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="65"
			height="65"
			fill="none"
			viewBox="0 0 65 65"
		>
			<g fill="#FEB4B4" clipPath="url(#clip0)">
				<path d="M22.24 56.5H43.5c1.1 0 2-.9 2-2V44.4c0-5.98-4.56-10.94-10.52-11.9 5.96-.98 10.52-5.94 10.52-11.9V10.5c0-1.1-.9-2-2-2H22.24c-1.1 0-2 .9-2 2v10.1c0 5.98 4.56 10.94 10.52 11.9-5.96.98-10.52 5.94-10.52 11.9v10.1c0 1.1.88 2 2 2zm2-4v-2.76H41.5v2.76H24.24zm17.26-40v4.58H24.24V12.5H41.5zm-17.22 8.58h17.16c-.28 4.22-4 7.6-8.58 7.6s-8.3-3.36-8.58-7.6zm8.58 15.24c4.76 0 8.64 3.62 8.64 8.1v1.32H24.24v-1.32c0-4.48 3.86-8.1 8.62-8.1zM46.5 60.5h-28v4h28v-4z"></path>
			</g>
			<defs>
				<clipPath id="clip0">
					<path
						fill="#fff"
						d="M0 0H64V64H0z"
						transform="translate(.5 .5)"
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default HourGlassRedUnderline;
